import React from "react";
const HoAssociation = ({ size = 24, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-labelledby="title desc" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <path d="M2,6 C6,10 10,14 14,10 C18,6 22,10 22,14" />
      <path d="M2,14 C6,10 10,6 14,10 C18,14 22,10 22,6" />
    </g>
  </svg>
);

export default HoAssociation;
